import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { AirportAlert, AlertPriority } from '../models/airport-alert.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditAlertComponent } from '../edit-alert/edit-alert.component';
import { DeleteAlertComponent } from '../delete-alert/delete-alert.component';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';


@Component({
  selector: 'app-airport-alert',
  templateUrl: './airport-alert.component.html',
  styleUrls: ['./airport-alert.component.scss']
})
export class AirportAlertComponent implements OnInit {
  @Input() airport: Airport;
  // airportAlerts: AirportAlert[];
  editModeSet: boolean;
  hide: boolean;
  constructor(private _toggleService: EditToggleService,
              public _snackBar: MatSnackBar,
              private _editAlertDialog: MatDialog,
              private _deleteAlertDialog: MatDialog) {
    // this.airportAlerts = this.airport.alerts;
  }

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  lowPriority(priority: AlertPriority): boolean {
    return (priority === AlertPriority.Low);
  }


  formatTitle(alert: AirportAlert): string {

    if (alert.effectiveDate === null || alert.expirationDate === null){
      this.hide = true;
    } else {
      this.hide = false;
    }



    let result = '';
    if (alert.title) {
      result += alert.title;
    }
    if (!this.hide) {

      if (alert.effectiveDate) {
        if (result) {
          result += ' - ';
        }

        result += 'EFFECTIVE ' + this.formatDate(alert.effectiveDate);
      }

      if (alert.expirationDate) {
        if (result) {
          result += ' - ';
        }
        result += 'EXPIRES ' + this.formatDate(alert.expirationDate);
      }
    }

    return result;
  }

  formatDate(input: Date): string {
    return (input.getMonth() + 1) + '/' + input.getDate() + '/' + input.getFullYear();
  }

  formatUrl(input: string): string {
    if (input.indexOf('http://') >= 0 || input.indexOf('https://') >= 0) {
      return input;
    } else {
      return 'http://' + input;
    }
  }

  openEditAlertDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      airID: this.airport.airportId,
      alertID: null,
      isNew: false
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.alert = this.airport.alerts[index];
    dialogConfig.data['airID'] = this.airport.airportId;
    dialogConfig.width = '60%';
    const dialogRef = this._editAlertDialog.open(EditAlertComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          this.airport.alerts.push(isUpdated.alert);
          this._snackBar.open('Alert', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Alert', 'Updated', {
            duration: 2000
          });
        }
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  deleteAlert(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      airID: this.airport.airportId,
      alertID: this.airport.alerts[index].alertId
    };
    const dialogRef = this._deleteAlertDialog.open(DeleteAlertComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('Alert', 'Deleted', {
          duration: 2000
        });
        this.airport.alerts.splice(index, 1);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
